import { getStore } from '../store/Store';
import { action } from 'satcheljs/lib/legacy';

export default action('setTypeOfItemBeingDragged')(function setTypeOfItemBeingDragged(
    dataItemType: string
) {
    const store = getStore();
    store.typeOfItemBeingDragged = dataItemType;
});
